
import { connect } from 'react-redux'
import { compose, branch, renderComponent, renderNothing } from 'recompose'
import PhotoCrop from './PhotoCrop'

const Component = compose(

  connect(state => {
    return {
      items: state.breadcrumb
    }
  }),
  branch(
    () => {
      return true
    },
    renderComponent(PhotoCrop),
    renderNothing
  )
)(PhotoCrop)

export default Component